import { Controller } from "stimulus";

export default class extends Controller {

  connect() {
    let params = new URLSearchParams(document.location.search);
    let openChatFrame = params.get("openChatFrame");
    if (openChatFrame != null) {
      
      let frame = document.getElementById('chats_list');
      frame.src="/chat_with_staff"
      frame.reload();
    }
  }

}